import React from 'react';
import {FormGroup} from '@blueprintjs/core';

import {SimpleSelect} from '../../select';

interface ISelectOptionsProps {
  selected: string;
  onChange: (value: string) => void;
  label: string;
  options: any[];
  disabled?: boolean;
  selectLabel?: string;
  className?: string;
}

export const SelectOptions = ({
  selected,
  onChange,
  label,
  options,
  disabled = false,
  selectLabel = undefined,
  className = undefined
}: ISelectOptionsProps) => {
  return (
    <FormGroup label={label} inline={true} className={className}>
      <SimpleSelect
        label={selectLabel}
        selected={selected}
        disabled={disabled}
        onChange={onChange}
        options={options}
        buttonProps={{
          minimal: true,
          fill: true,
          small: true,
          outlined: true,
        }}
        popoverProps={{
          usePortal: true
        }}
      />
    </FormGroup>
  );
};

export default SelectOptions;
